import React from "react";
import Frame from "../chrome/Frame";
import Meta from "../chrome/Meta";
import ApproachSteps from "../parts/Approach";
import Pillars from "../parts/Pillars";
import Invite from "../parts/Invite";

const Approach = () => (
  <Frame>
    <Meta title="Approach" description="CMV Vision's four-stage delivery rhythm — listen, frame, ship, compound." />
    <section className="svc-hero">
      <div className="shell">
        <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Approach</div>
        <span className="eyebrow">Approach</span>
        <h1>A four-stage rhythm, engineered to be boring on purpose.</h1>
        <p className="lede">
          Surprises in marketing programmes are almost never good. This is the operating system we run on every
          engagement — regardless of whether it is two weeks of strategy or a two-year retainer.
        </p>
      </div>
    </section>
    <section className="band">
      <div className="shell">
        <ApproachSteps />
      </div>
    </section>
    <section className="band band--cream">
      <div className="shell">
        <div className="section-title">
          <div className="left">
            <span className="eyebrow">Commitments</span>
            <h2>Four principles, written into every contract.</h2>
            <p>If we breach one, you have a contractual right to terminate without penalty.</p>
          </div>
        </div>
        <Pillars />
      </div>
    </section>
    <Invite />
  </Frame>
);

export default Approach;
